<form name="ftForm" id="ftForm" role="form">
  <ng-container #ngMainCont></ng-container>
</form>

<ng-template #ngMainTpl>
  <ft-template ftFormColor [formParameters]="formParameters" 
              [user]="user"
              >
  </ft-template>
</ng-template>